import DDBorrowMore from 'features/advance/screens/lightning/IntroPage/components/DDBorrowMore/DDBorrowMore';
import IntroScreen from 'features/advance/screens/lightning/IntroPage/components/IntroScreen/IntroScreen';
import React from 'react';
import { FeatureFlagKey } from 'services/statsig/types';
import { useStatsig } from 'shared/hooks/statsig/useStatsig';
import { PinwheelContextProvider } from 'shared/providers/pinwheel/PinwheelContextProvider/PinwheelContextProvider';

const Intro = () => {
  const { isFeatureEnabled } = useStatsig();

  const isLightningDDEnabled = isFeatureEnabled(
    FeatureFlagKey.ENABLE_LIGHTNING_DD,
  );

  return isLightningDDEnabled ? (
    <PinwheelContextProvider>
      <DDBorrowMore />
    </PinwheelContextProvider>
  ) : (
    <IntroScreen />
  );
};

export default Intro;
